type BackgroundColorType = string;

export const productTypeColorMap: Record<string, BackgroundColorType> = {
  // English product types
  // Fern 100 bg-[#D2DAD8]
  // Fern 200 bg-[#A5B5B1]

  Bachelors: "bg-[#D2DAD8]",
  "Certificate Program": "bg-putty-200",
  Course: "bg-putty-500",
  "Doctoral Program": "bg-[#D2DAD8]",
  "Offered on Emeritus": "bg-gray-100",
  "Executive Education": "bg-[#A5B5B1]",
  "Licensure Program": "bg-putty-200",
  Masters: "bg-[#D2DAD8]",
  MicroBachelors: "bg-putty-200",
  MicroMasters: "bg-putty-200",
  "Professional Certificate": "bg-putty-200",
  "Offered through Shorelight": "bg-gray-100",
  XSeries: "bg-putty-200",

  // Spanish product types
  Licenciatura: "bg-[#D2DAD8]",
  "Programa de certificación": "bg-putty-200",
  Curso: "bg-putty-500",
  "Programa de doctorado": "bg-[#D2DAD8]",
  "Disponible en Emeritus": "bg-gray-100",
  "Educación ejecutiva": "bg-[#A5B5B1]",
  "Programa de licenciatura": "bg-putty-200",
  "Título de maestría": "bg-[#D2DAD8]",
  "Certificado profesional": "bg-putty-200",
  "Disponible en Shorelight": "bg-gray-100",
};

export const getTypeBackgroundColor = (type: string): BackgroundColorType => {
  return productTypeColorMap[type] || "bg-gray-100";
};
